// extracted by mini-css-extract-plugin
export var chevron = "_3e-d";
export var disabled = "_3e-b";
export var error = "_3e-c";
export var hideBorder = "_3e-1";
export var icon = "_3e-e";
export var input = "_3e-0";
export var open = "_3e-9";
export var placeholder = "_3e-a";
export var regular = "_3e-5";
export var singleRowInput = "_3e-2";
export var singleSelectInput = "_3e-3 _3e-0";
export var small = "_3e-4";
export var spinnerContainer = "_3e-g";
export var tag = "_3e-7";
export var tagsContainer = "_3e-8";
export var tagsInput = "_3e-6 _3e-0";
export var xSmall = "_3e-f";